<script>
import ToggleTab from "./AppIconTab.vue";
import TogglePlayer from "./VideoTogglePlayer.vue";
export default {
  components: {
    ToggleTab,
    TogglePlayer,
  },
  props: {
    slides: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      activePlayer: "video1",
    };
  },
  methods: {
    updatePlayer(payload) {
      console.log(payload);
      this.activePlayer = payload;
    },
  },
};
</script>

<template>
  <article>
    <div class="content-wrapper vw-grid">
      <TogglePlayer
        class="leftBleed"
        :active-video="activePlayer"
        :slides="slides"
      />
      <ul class="tabList" ref="tabs">
        <ToggleTab
          v-for="slide in slides"
          @click.native="updatePlayer(slide.id)"
          :key="slide.id"
          :slide="slide"
          :active="activePlayer"
          class="pointerCursor"
        />
      </ul>
    </div>
  </article>
</template>

<style lang="scss" scoped>
article {
  position: relative;
  padding: 30px;
  padding-top: 0;
  background-color: var(--background-color);
  color: var(--text-color);
  --tab-padding: 30px;
}
.content-wrapper {
  max-width: var(--max-cont-w);
  width: 100%;
}
.tabList {
  grid-column: 7 / span 6;
  list-style: none;
  margin-bottom: 0;
  margin-top: 0;
  padding: 0;
  text-align: left;
}
li {
  // height: 257px;
  cursor: pointer;
}
.leftBleed {
  grid-column: 1/7;
}
.pointerCursor {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// resources/assets/vuejs/frontend/2023-launch/components/VideoToggle.vue